import type { ThemeComponentType } from '../types';

export const Paper: ThemeComponentType = {
  defaultProps: {
    p: 'lg',
    shadow: 'xs',
  },
};
